import { PageLoaderComponent, PageLoad } from '@app/shared/components/page-loader/page-loader.component';
import { FilterChipsComponent, FilterChip } from '@app/shared/components/filter-bar/filter-chips.component';
import { SearchPillComponent } from '@app/shared/components/filter-bar/search-pill.component';
import { PageTitleComponent } from '@app/shared/components/page-title/page-title.component';
//Angular Modules
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { ModulesService } from '@app/shared/services/modules.service';
import { ErrorStateMatcher } from '@angular/material/core';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
//Shared Services
import { SimpleExcelService } from '@app/shared/services/simple-excel.service';
import { TableStructureModel } from '@app/shared/models/table.model';
import { PdfService } from '@app/shared/services/pdf.service';
//import { UploadFileDialogService } from '@app/upload-file-dialog/upload-file-dialog.service';
//Core Services
import { LoggerService } from '@app/logger/logger.service';
import { CustomMessageService } from '@app/shared/components/custom-message/custom-message.service';
import { NetworkService } from '@app/shared/services/network.service';
//Entity services
import { RolePermissionsService } from '@shared/services/auth/role-permissions.service';
import { HistoryService } from '@app/shared/services/entities/history.service';
import { UsersService } from '@app/shared/services/entities/users.service';
import { PlacesService } from '@app/shared/services/entities/places.service';
import { WarehousesService } from '@app/shared/services/entities/warehouse.service';
import { SpecialtyService } from '@app/shared/services/entities/specialty.service';
import { ContractsService } from '@app/shared/services/entities/contracts.service';
import { ProductsService } from '@app/shared/services/entities/products.service';
import { ManufacturerService } from '@app/shared/services/entities/manufacturers.service';
import { StockService } from '@app/shared/services/entities/stock.service';
import { InterventionsService } from '@app/shared/services/entities/interventions.service';
import { DoctorsService } from '@app/shared/services/entities/doctors.service';
import { ProcedureService } from '@app/shared/services/entities/procedure.service';
import { SupplierService } from '@app/shared/services/entities/supplier.service';
import { MatAccordion } from '@angular/material/expansion';
import { RolesService } from '@app/shared/services/entities/roles.service';
import { OperationRoomsService } from '@app/shared/services/entities/operationRooms.service';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
//Module Components

const log = new LoggerService('HISTORY AUDIT SERVICE');

/** Error cuando un control es invalido. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
      const isSubmitted = form && form.submitted;
      return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

import { ListSelection, ListView } from '@app/shared/utils/list-view';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
@Component({
  standalone: true,
  imports: [ MatTooltipModule, MatButtonToggleModule,PageLoaderComponent, SearchPillComponent, FilterChipsComponent, PageTitleComponent, 
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
],
  selector: 'app-history-audit',
  templateUrl: './history-audit.component.html',
  styleUrls: ['../audit-page.scss']
})
export class HistoryAuditComponent implements OnInit {
  readonly listView = new ListView('audit-history', 'table');
  /** Título = etiqueta visible del módulo (tabla `modules`). */
  readonly pageLabel = inject(ModulesService).moduleTitle('/audit/history', 'Historial de ediciones');

  isSlowConnection = false; //Validar conexión de red

  //Controladores del modulo
  loaded: boolean = false;
  toolSpinner: boolean = true;
  selectModule: boolean = true;

  @ViewChild(MatAccordion) accordion!: MatAccordion;

  //Custom Message
  errorMessageTime = 2000;
  successMessageTime = 2000;

  organization: any;

  closed:boolean = true;

  //Form para selectores
  public FormInfo!: FormGroup;
  formControl: boolean = false;
  matcher = new MyErrorStateMatcher();

  value = 'Limpiar';

  //Selector de fechas
  dateRangeForm = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });
  startDate: any;
  endDate: any

  //Roles de los diversos tipos de usuarios
  public roleList: any[] = [];
  public operationRoleList = ['Director Operaciones','Subdirector Operaciones','Gerente Técnico Médico','Gerente Administrativo','Supervisor Administrativo','Coordinador Administrativo','Gestor Administrativo','Supervisor Especialista de Abasto Médico','Coordinador Especialista de Abasto Médico','Especialista de Abasto Médico','Supervisor Técnico Medico','Coordinador Técnico Medico','Técnico Especialista',"Técnico Especialista - Gestor Administrativo","Especialista de Abasto Médico - Gestor Administrativo","Técnico Especialista - Especialista de Abasto Médico - Gestor Administrativo",'Gerente','Compras','Especialista','Finanzas'];
  public tecnicoRoleList = ['Supervisor Técnico Medico','Coordinador Técnico Medico','Técnico Especialista',"Técnico Especialista - Gestor Administrativo","Técnico Especialista - Especialista de Abasto Médico - Gestor Administrativo",'Gerente'];
  public almacenistaRoleList = ['Supervisor Especialista de Abasto Médico','Coordinador Especialista de Abasto Médico','Especialista de Abasto Médico',"Especialista de Abasto Médico - Gestor Administrativo","Técnico Especialista - Especialista de Abasto Médico - Gestor Administrativo"];

  //Objetos para las diferentes entidades modificadas (para reemplazar ids con su valor correspondiente)
  public manufacturerObject = [];
  public usersObject = [];
  public contractsObject = [];
  public stockObject = [];
  public operationRoomsObject = [];
  public doctorObject = [];
  public supplierObject = [];
  public interventionObject = [];
  public warehouseObject = [];
  public placesObject = [];
  public specialtyObject = [];
  public productObject = [];
  public organizationObject = [];
  public procedureObject: any[] = [];

  //Módulos elegibles: `table` es el nombre con el que la API guarda el
  //historial; `route` sirve para tomar la etiqueta visible del módulo.
  private readonly modulesService = inject(ModulesService);
  private readonly MODULE_TABLES: { table: string; route: string; label: string; alt?: string[] }[] = [
    { table: 'products',          route: '/catalogues/products',          label: 'Insumos' },
    { table: 'places',            route: '/catalogues/places',            label: 'Ubicaciones' },
    { table: 'doctors',           route: '/catalogues/doctors',           label: 'Médicos' },
    { table: 'specialties',       route: '/catalogues/specialties',       label: 'Especialidades' },
    { table: 'procedures',        route: '/catalogues/procedures',        label: 'Cirugías' },
    { table: 'warehouses',        route: '/catalogues/warehouses',        label: 'Lockers' },
    { table: 'inhouses',          route: '/catalogues/inhouses',          label: 'In-house', alt: ['/catalogues'] },
    { table: 'rfiddevices',       route: '/catalogues/rfidDevices',       label: 'Tecnología RFID', alt: ['/catalogues'] },
    { table: 'equipments',        route: '/catalogues/equipments',        label: 'Equipos' },
    { table: 'instrumentals',     route: '/catalogues/instrumentals',     label: 'Instrumental' },
    { table: 'hospitalServices',  route: '/catalogues/hospitalServices',  label: 'Servicios hospitalarios' },
    { table: 'kits',              route: '/catalogues/kits',              label: 'Kits' },
    { table: 'substitutes',       route: '/catalogues/substitutes',       label: 'Insumos sustitutos' },
    { table: 'manufacturers',     route: '/catalogues/manufacturers',     label: 'Fabricantes' },
    { table: 'brands',            route: '/catalogues/brands',            label: 'Marcas' },
    { table: 'suppliers',         route: '/catalogues/suppliers',         label: 'Proveedores' },
    { table: 'operationrooms',    route: '/catalogues/operationRooms',    label: 'Quirófanos' },
    { table: 'interventions',     route: '/interventions/folios',         label: 'Folios', alt: ['/interventions'] },
    { table: 'remissions',        route: '/interventions/remissions',     label: 'Remisiones', alt: ['/remissions', '/interventions'] },
    { table: 'shippings',         route: '/materialReception',            label: 'Recepción / movimientos de material' },
    { table: 'stock',             route: '/inventory',                    label: 'Inventario de insumos' },
    { table: 'stockequipments',   route: '/inventoryEquipments',          label: 'Inventario de equipos' },
    { table: 'stockeinstrumentals', route: '/inventoryInstrumentals',     label: 'Inventario de instrumental' },
    { table: 'incidents',         route: '/incidents',                    label: 'Incidencias' },
    { table: 'supporttickets',    route: '/support',                      label: 'Soporte' },
    { table: 'users',             route: '/users',                        label: 'Usuarios' },
    { table: 'roles',             route: '/roles',                        label: 'Roles' },
    { table: 'modules',           route: '/modules',                      label: 'Módulos' },
    { table: 'contracts',         route: '/contracts',                    label: 'Contratos' },
  ];
  public moduleOptions: { value: string; name: string }[] = [];

  /** Filtros de la consulta por módulo. */
  public selectedTable: string | null = null;
  public kindFilter: '' | 'CREADO' | 'EDITADO' | 'BORRADO' = '';
  public textFilter = '';
  public readonly kindOptions = [
    { value: '',        label: 'Todos' },
    { value: 'CREADO',  label: 'Creado' },
    { value: 'EDITADO', label: 'Editado' },
    { value: 'BORRADO', label: 'Borrado' },
  ];
  /** uiData ya filtrado por tipo y texto (lo que se pagina y exporta). */
  public viewData: any[] = [];

  /**
   * Módulos que puede consultar el usuario: los de SU ROL (navAccessTree) y
   * activos, con la etiqueta visible de la tabla `modules`. Si el rol no
   * tiene módulos asignados (menú de respaldo) se muestran todos.
   */
  private async loadModuleOptions(): Promise<void> {
    const norm = (r: any) => String(r ?? '').split('?')[0].split('#')[0].replace(/\/+$/, '').toLowerCase();
    let modules: any[] = [];
    let nav: string[] | null = null;
    try {
      const resp: any = await this.modulesService.search({ searchType: 'default', condition: { deleted: false } });
      modules = (resp?.data ?? []) as any[];
      const user = this.usersService.currentUser() ?? await this.usersService.loadCurrentUser();
      if (user?.role) {
        const rolesResp: any = await this.rolService.search({ searchType: 'default', condition: { id: user.role } });
        const role = rolesResp?.data?.[0];
        nav = Array.isArray(role?.navAccessTree) && role.navAccessTree.length ? role.navAccessTree : null;
      }
    } catch { /* sin datos: se muestran todas con su nombre por omisión */ }

    const byRoute = new Map<string, any>();
    modules.forEach(m => byRoute.set(norm(m.route), m));
    const allowed = (m: any) => !!m && m.active !== false && (!nav || nav.includes(m.id));

    const options: { value: string; name: string }[] = [];
    for (const t of this.MODULE_TABLES) {
      const routes = [t.route, ...(t.alt ?? [])];
      const found = routes.map(r => byRoute.get(norm(r))).filter(Boolean);
      if (modules.length && nav) {
        // Con rol y módulos en BD: solo si el rol tiene alguno de sus módulos.
        const ok = found.find(allowed);
        if (!ok) continue;
        const own = byRoute.get(norm(t.route));
        options.push({ value: t.table, name: String((own && allowed(own) ? (own.label || own.name) : null) || t.label) });
      } else {
        const own = byRoute.get(norm(t.route));
        if (own && own.active === false) continue;
        options.push({ value: t.table, name: String(own?.label || own?.name || t.label) });
      }
    }
    this.moduleOptions = options.sort((a, b) => a.name.localeCompare(b.name, 'es'));
    if (this.selectedTable && !this.moduleOptions.some(o => o.value === this.selectedTable)) this.selectedTable = null;
  }

  get selectedModuleLabel(): string {
    return this.moduleOptions.find(m => m.value === this.selectedTable)?.name ?? '';
  }

  kindClass(kind: string): string {
    return kind === 'CREADO' ? 'kind kind--new' : kind === 'BORRADO' ? 'kind kind--del' : 'kind kind--edit';
  }

  module: any;

  elements: any[] = []

  uiData: any[] = [];

  //Paginación
  length: number = 0;
  pageSize: number = 10;
  pageSizeOptions: number[] = [10, 25, 50, 100];
  pagedList: any[] = [];
  pageEvent!: PageEvent;

  constructor(
    private router: Router,
    private historyService: HistoryService,
    private simpleExcelService: SimpleExcelService,
    private doctorsService: DoctorsService,
    private productsService: ProductsService,
    private contractsService: ContractsService,
    private specialtyService: SpecialtyService,
    private supplierService: SupplierService,
    private usersService: UsersService,
    private manufacturerService: ManufacturerService,
    private placesService: PlacesService,
    private warehouseService: WarehousesService,
    private stockService: StockService,
    private interventionsService: InterventionsService,
    private customMessageService: CustomMessageService,
    private procedureService: ProcedureService,
    private formBuilder: FormBuilder,
    private networkService: NetworkService,
    private rolService: RolesService,
    private operationRoomsService: OperationRoomsService
  ) {
  }

  /** Pantalla de carga del módulo: bloquea hasta terminar la carga inicial. */
  readonly pageLoad = new PageLoad();

  ngOnInit(): void {
    void this.init();
  }

  /** Carga inicial (también la usa "Reintentar"). */
  init(): Promise<boolean> {
    return this.pageLoad.run(() => this.initialLoad());
  }

  private async initialLoad(): Promise<void> {
    this.FormInfo = this.formBuilder.group({
      element: [null, Validators.required]
    });
    void this.loadModuleOptions();

    try{
      this.customMessageService.open({ title: "Espere",type: 'success', message: 'Cargando datos iniciales', loading: true });
      //Validar el estado de la conexión
      this.networkService.isConnectionSlow$.subscribe(slow => {
        this.isSlowConnection = slow;
      });

      let apiRoleList = await this.rolService.getAllRols();
      //log.debug('[ngOnInit] apiRoleList', apiRoleList)
      this.roleList = apiRoleList.data.map(role => role.name);

      // La organización sale del usuario en sesión. Antes se pedía al
      // `epione-core-api` a través de `NavigationService`, se filtraba el
      // remote con título 'EVOLUTION' y de ahí se tomaba. Ese servicio era
      // del shell de Module Federation; hoy la organización es una sola,
      // fija por despliegue (ORGANIZATION_ID en el API), y ya viene en el
      // registro del usuario. Solo se usa para mostrar un valor legible en
      // la columna `organization` del historial de movimientos.
      const currentUser = this.usersService.currentUser()
        ?? await this.usersService.loadCurrentUser();
      this.organization = currentUser?.organization ?? 'N/A';

      await Promise.all([
        await this.getUsers(),
        await this.getContracts(),
        await this.getDoctors(),
        await this.getSuppliers(),
        await this.getInterventions(),
        await this.getSpecialties(),
        await this.getWarehouses(),
        await this.getPlaces(),
        await this.getProducts(),
        await this.getManufacturers(),
        await this.getProcedures(),
        await this.getOperationRooms(),
      ]);

      }catch (error) {
        // La pantalla de carga muestra el error con "Reintentar".
        throw new Error('Error al cargar los datos iniciales: ' + error);
      } finally {
        try{
          await this.getInventory();
        }catch(error){
          await this.customMessageService.open({
            title: 'Error',
            type: 'error',
            message: 'Error al cargar los datos de inventario: ' + error,
            dismissBtn: true
          });
        }
        // Cerrar el mensaje de carga único
        this.customMessageService.close();
        this.toolSpinner = false;
      }
  }

  async getUsers(){
    try{
      // TODOS los usuarios (antes solo administradores: quien editaba con
      // otro rol salía como "N/A" en "Modificado por").
      let apiResponse = await this.usersService.getUsers([]);
      log.debug('[getUsers] apiResponse', apiResponse)
      if (apiResponse.state === 'success') {
        let usersList = apiResponse.data;
        this.usersObject = usersList.reduce(function (r, a) {
          const label = a['name'] || a['email'] || a['id'];
          r[a['id']] = label;
          if (a['email']) r[a['email']] = label;
          if (a['sub']) r[a['sub']] = label;
          return r;
        }, Object.create(null));
        log.debug('[getUsers] usersObject', this.usersObject)
      } else {
        throw new Error(apiResponse.message);
      }
      }catch (err){
        throw err;
      }
  }

  async getContracts(){
    try{
      const userResponse = await this.usersService.getUsers(this.roleList);
      if (userResponse.state === 'success') {
        const contractResponse = await this.contractsService.search({searchType:'default',condition:{deleted:false}})
        if (contractResponse.state === 'success') {
          let contractsList = contractResponse.data;
          this.contractsObject = contractsList.reduce(function (r, a) {
            r[a['id']] = r[a['id']] || [];
            r[a['id']] = a['name'];
            return r;
          }, Object.create(null));
          //log.debug('[getContracts] contractsObject',this.contractsObject)
        }
      } 
      }catch (error) {
        this.customMessageService.open({title: "Error",type: 'error',message: error,duration: 2000,});
        throw new Error(error);
      }
  }

  async getInventory(){
    if(Object.keys(this.warehouseObject).length !== 0){
      for(let wh in this.warehouseObject){
        try{
          
          let stockResponse: Utils.ApiResponse<any> = await this.stockService.search({searchType:'default',condition:{deleted: false, status: ['Disponible', 'Caduco','Merma'], warehouse: wh}});
          //log.debug('[getInventory] stockResponse',stockResponse)
          if (stockResponse.state === 'success' && stockResponse.data[0] !== null ) {
            let stockList = stockResponse.data;
              let whObj = stockList.reduce(function (r, a) {
                r[a['id']] = r[a['id']] || [];
                r[a['id']] = a['tagRfid'];
                return r;
              }, Object.create(null));
              this.stockObject = {...this.stockObject, ...whObj};
          } 
        }catch (error) {
          this.customMessageService.open({title: "Error",type: 'error',message: error,duration: 2000,});
          throw new Error(error);
        }
      }
      //log.debug('[getInventory] stockObject',this.stockObject)
    }
  }

  async getDoctors(){
    try{
      const userResponse = await this.usersService.getUsers(this.roleList);
      if (userResponse.state === 'success') {
        const doctorsResponse = await this.doctorsService.search({searchType:'default',condition:{deleted:false}})
        if (doctorsResponse.state === 'success') {
          let doctorList = doctorsResponse.data;
          this.doctorObject = doctorList.reduce(function (r, a) {
            r[a['id']] = r[a['id']] || [];
            r[a['id']] = a['name'];
            return r;
          }, Object.create(null));
          //log.debug('[getDoctors] doctorObject',this.doctorObject)
        }
      } 
      }catch (error) {
        this.customMessageService.open({title: "Error",type: 'error',message: error,duration: 2000,});
        throw new Error(error);
      }
  }

  async getSuppliers(){
    try{
      const userResponse = await this.usersService.getUsers(this.roleList);
      if (userResponse.state === 'success') {
        const supplierResponse = await this.supplierService.search({searchType:'default',condition:{deleted:false}})
        //log.debug('[getSuppliers] supplierResponse', supplierResponse)
        if (supplierResponse.state === 'success') {
          let supplierList = supplierResponse.data;
          this.supplierObject = supplierList.reduce(function (r, a) {
            r[a['id']] = r[a['id']] || [];
            r[a['id']] = a['name'];
            return r;
          }, Object.create(null));
          //log.debug('[getSuppliers] supplierObject',this.supplierObject)
        }
      } 
      }catch (error) {
        this.customMessageService.open({title: "Error",type: 'error',message: error,duration: 2000,});
        throw new Error(error);
      }
  }

  async getInterventions(){
    try{
      const userResponse = await this.usersService.getUsers(this.roleList);
      if (userResponse.state === 'success') {
        const interventionResponse = await this.interventionsService.search({searchType:'default',condition:{deleted:false}})
        if (interventionResponse.state === 'success') {
          let interventionList = interventionResponse.data;
          this.interventionObject = interventionList.reduce(function (r, a) {
            r[a['id']] = r[a['id']] || [];
            r[a['id']] = a['fileNumber'];
            return r;
          }, Object.create(null));
          //log.debug('[getInterventions] interventionObject',this.interventionObject)
        } 
      } 
      }catch (error) {
        this.customMessageService.open({title: "Error",type: 'error',message: error,duration: 2000,});
        throw new Error(error);
      }
  }

  async getSpecialties(){
    try{
      const userResponse = await this.usersService.getUsers(this.roleList);
      if (userResponse.state === 'success') {
        const specialtyResponse = await this.specialtyService.search({searchType:'default',condition:{deleted:false}})
        if (specialtyResponse.state === 'success') {
          let specialtyList = specialtyResponse.data;
          this.specialtyObject = specialtyList.reduce(function (r, a) {
            r[a['id']] = r[a['id']] || [];
            r[a['id']] = a['name'];
            return r;
          }, Object.create(null));
          //log.debug('[getSpecialties] specialtyObject',this.specialtyObject)
        }
      } 
      }catch (error) {
        this.customMessageService.open({title: "Error",type: 'error',message: error,duration: 2000,});
        throw new Error(error);
      }
  }

  async getWarehouses(){
    try{
      const userResponse = await this.usersService.getUsers(this.roleList);
      //log.debug('[getWarehouses] userResponse',userResponse)
      if (userResponse.state === 'success') {
        const warehouseResponse = await this.warehouseService.search({searchType:'default',condition:{deleted:false}})
        //log.debug('[getWarehouses] warehouseResponse',warehouseResponse)
        if (warehouseResponse.state === 'success') {
          let warehouseList = warehouseResponse.data;
          this.warehouseObject = warehouseList.reduce(function (r, a) {
            r[a['id']] = r[a['id']] || [];
            r[a['id']] = a['name'];
            return r;
          }, Object.create(null));
          //log.debug('[getWarehouses] warehouseObject',this.warehouseObject)
        }
      } 
      }catch (error) {
        this.customMessageService.open({title: "Error",type: 'error',message: error,duration: 2000,});
        throw new Error(error);
      }
  }

  async getPlaces(){
    try{
      const userResponse = await this.usersService.getUsers(this.roleList);
      if (userResponse.state === 'success') {
        const placeResponse = await this.placesService.search({searchType:'default',condition:{deleted:false}})
        if (placeResponse.state === 'success') {
          let placesList = placeResponse.data;
          this.placesObject = placesList.reduce(function (r, a) {
            r[a['id']] = r[a['id']] || [];
            r[a['id']] = a['name'];
            return r;
          }, Object.create(null));
          //log.debug('[getPlaces] placesObject',this.placesObject)
        }
      } 
      }catch (error) {
        this.customMessageService.open({title: "Error",type: 'error',message: error,duration: 2000,});
        throw new Error(error);
      }
  }

  async getProducts(){
    try{
      const userResponse = await this.usersService.getUsers(this.roleList);
      if (userResponse.state === 'success') {
        const productResponse = await this.productsService.search({searchType:'default',condition:{deleted:false}})
        if (productResponse.state === 'success') {
          let productList = productResponse.data;
          //log.debug('[getFields] productList',productList)
          this.productObject = productList.reduce(function (r, a) {
            r[a['id']] = r[a['id']] || [];
            r[a['id']] = a['code'];
            return r;
          }, Object.create(null));
          //log.debug('[getProducts] productObject',this.productObject)
        } 
      } 
      }catch (error) {
        this.customMessageService.open({title: "Error",type: 'error',message: error,duration: 2000,});
        throw new Error(error);
      }
  }

  async getManufacturers(){
    try{
      const userResponse = await this.usersService.getUsers(this.roleList);
      if (userResponse.state === 'success') {
        const manufacturerResponse = await this.manufacturerService.search({searchType:'default',condition:{deleted:false}})
        if (manufacturerResponse.state === 'success') {
          let manufacturerList = manufacturerResponse.data;
          this.manufacturerObject = manufacturerList.reduce(function (r, a) {
            r[a['id']] = r[a['id']] || [];
            r[a['id']] = a['name'];
            return r;
          }, Object.create(null));
          //log.debug('[getManufacturers] manufacturerObject',this.manufacturerObject)
        }
      } 
      }catch (error) {
        this.customMessageService.open({title: "Error",type: 'error',message: error,duration: 2000,});
        throw new Error(error);
      }
  }

  async getProcedures(){
    try{
      const userResponse = await this.usersService.getUsers(this.roleList);
      if (userResponse.state === 'success') {
        const procedureResponse = await this.procedureService.search({searchType:'default',condition:{deleted:false}})
        if (procedureResponse.state === 'success') {
          let procedureList = procedureResponse.data;
          this.procedureObject = procedureList.reduce(function (r, a) {
            r[a['id']] = r[a['id']] || [];
            r[a['id']] = a['name'];
            return r;
          }, Object.create(null));
          //log.debug('[getFields] procedureObject',this.procedureObject)
        }
      } 
      }catch (error) {
        this.customMessageService.open({title: "Error",type: 'error',message: error,duration: 2000,});
        throw new Error(error);
      }
  }

  /*** @description Buscar salas de operacion */
  async getOperationRooms(){
    try{
      let response = await this.operationRoomsService.search({searchType:'default',condition:{deleted:false}});
      let operationRoomsList = response['data'];
      this.operationRoomsObject = operationRoomsList.reduce(function (r, a) {
            r[a['id']] = r[a['id']] || [];
            r[a['id']] = a['name'];
            return r;
          }, Object.create(null));
    }catch(err){
      throw err;
    }
  }


  /** Paginador. */
  OnPageChange(event: PageEvent) {
    let startIndex = event.pageIndex * event.pageSize;
    let endIndex = startIndex + event.pageSize;
    if (endIndex > this.length) {
      endIndex = this.length;
    }
    this.pagedList = this.viewData.slice(startIndex, endIndex);
    return event;
  }

  /** Quita un elemento de la lista por buscar (antes de consultar). */
  removeElement(index: number): void {
    if (this.loaded || this.toolSpinner) return;
    this.elements.splice(index, 1);
  }

  setSearch(){
    let value = this.FormInfo.get('element').value
    .replace(/&|<|>|"|'/g, match => ({'&': '&amp;','<': '&lt;','>': '&gt;','"': '&quot;',"'": '&#39;'}[match]!)).toUpperCase().trim(); //Sanitizar caracteres especiales en HTML
    if(this.elements.includes(value)){
      this.customMessageService.open({title: "Error", type: 'error', message: `Ese elemento ya fue ingresado`, duration: this.errorMessageTime });
      return
    }
    this.elements.push(value);
    this.FormInfo.get('element')?.reset()
  }

/** Obtener TODO el historial del módulo seleccionado. */
  async getHistory(){
      if (!this.selectedTable) return;
      this.accordion?.closeAll();
      this.uiData = [];
      this.customMessageService.open({ title: "Cargando",type: 'success', message: 'Buscando historial', loading: true });
      let apiResponse: any;
      try {
        apiResponse = await this.historyService.search({searchType:'default',condition:{deleted:false, table: this.selectedTable}});
      } catch (err) {
        apiResponse = null;
      }
      this.customMessageService.close();
      const history = (apiResponse?.state == 'success' ? (apiResponse.data ?? []) : []).filter((h: any) => h && Array.isArray(h.movements));
      this.loaded = true;
      if(history.length !== 0) this.matchIds(history); //Reemplazar todas las llaves que tengan guardado un id por su valor correspondiente
      else{
        await this.customMessageService.open({title: "Sin historial",type: 'neutral', message: `No hay historial para <b>${this.selectedModuleLabel}</b>.`, dismissBtn: true });
        this.applyView();
      }
  }

  /** Nombres en español de los campos que aparecen en el historial. */
  private static readonly ATTRIBUTE_LABELS: Record<string, string> = {
    name: 'Nombre', alias: 'Alias', location: 'Ubicación', type: 'Tipo', active: 'Activo', deleted: 'Eliminado',
    provider: 'Proveedor',
    specialty: 'Especialidad', place: 'Ubicación', places: 'Hospitales', hospital: 'Hospital', doctor: 'Médico',
    code: 'Código', description: 'Descripción', manufacturer: 'Fabricante', productGroup: 'Grupo de insumos',
    alg: 'ALG', UOM: 'Unidad de medida', price: 'Precio', image: 'Foto', responsible: 'Responsable',
    warehouse: 'Locker', status: 'Estado', priority: 'Prioridad', folio: 'Folio', fileNumber: 'Folio',
    technician: 'Técnico', patient: 'Paciente', procedure: 'Cirugía', operationRoom: 'Quirófano',
    interventionDatetime: 'Fecha y hora de la cirugía', episode: 'Episodio', cir: 'CIR', service: 'Servicio hospitalario',
    comments: 'Comentarios', notes: 'Notas', startHour: 'Inicio de Cx', finishHour: 'Fin de Cx',
    surgicalEquipment: 'Equipo de cirugía', products: 'Insumos', otherItems: 'Otros', wizardStep: 'Paso del asistente',
    contract: 'Contrato', line: 'Línea', cot: 'COT', mdtCode: 'Código MDT', epioneCode: 'Código EPIONE',
    quantity: 'Cantidad', batch: 'Lote', expiration: 'Caducidad', tagRfid: 'RFID', label: 'Etiqueta', icon: 'Ícono',
    route: 'Ruta', navAccessTree: 'Módulos del rol', accessPermissions: 'Permisos', role: 'Rol', email: 'Correo',
    phone: 'Teléfono', subject: 'Asunto', module: 'Módulo', moduleId: 'Módulo', assignedTo: 'Asignado a',
    assignedToName: 'Asignado a', resolution: 'Resolución', resolvedOn: 'Fecha de resolución',
    estimatedHours: 'Tiempo estimado (h)', ticketType: 'Tipo de ticket', requestedBy: 'Solicitante',
    requestedByName: 'Solicitante', catalogItem: 'Pieza del catálogo', equipmentName: 'Pieza', serialNumber: 'Número de serie',
    needsReplacement: '¿Necesita remplazo?', reason: 'Razón', interventionFolio: 'Folio/Remisión',
    hospitalService: 'CIR (servicio)', nameVariants: 'Variantes de nombre', productId: 'Insumo', substituteId: 'Insumo sustituto',
    sapCode: 'Código SAP', rfidDevice: 'Dispositivo RFID', createdBy: 'Creado por', organization: 'Organización',
    reportedByName: 'Reportó', doctorName: 'Médico', items: 'Partidas', intervention: 'Folio de cirugía',
    legal_name: 'Razón social', tax_id: 'RFC', address: 'Dirección', model: 'Modelo', brand: 'Marca', supplier: 'Proveedor',
    equipment: 'Equipo', equipments: 'Equipos', min_stock: 'Inventario mínimo', max_stock: 'Inventario máximo',
    folioPrefix: 'Serie de folio', folioConsecutive: 'Último consecutivo', institution: 'Cliente', services: 'Servicios',
    maxQuantity: 'Cantidad máxima', usageFactor: 'Factor de uso', itemNumber: 'Partida', contractFileNumber: 'Folio de contrato',
    order: 'Pedido', delivery: 'Entrega', consumption: 'Consumo', refund: 'Devolución', numberUses: 'Número de usos',
    specialties: 'Especialidades', procedures: 'Cirugías', operationRooms: 'Quirófanos', startsOn: 'Inicio', endsOn: 'Fin',
  };

  private attributeLabel(attr: string | null | undefined): string {
    if (!attr) return 'N/A';
    const known = HistoryAuditComponent.ATTRIBUTE_LABELS[attr];
    if (known) return known;
    // Respaldo: camelCase / snake_case → palabras.
    const words = String(attr).replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
    return words.charAt(0).toUpperCase() + words.slice(1);
  }

  /** Valores simples legibles: booleanos, números y vacíos (antes salían "N/A"). */
  private plainValue(attr: string, v: any): any {
    if (v === null || v === undefined || v === '') return '—';
    if (typeof v === 'boolean') {
      if (attr === 'active') return v ? 'Activo' : 'Inactivo';
      if (attr === 'deleted') return v ? 'Eliminado' : 'No eliminado';
      return v ? 'Sí' : 'No';
    }
    if (typeof v === 'number') return String(v);
    return v;
  }

  /** Tipo de edición de un movimiento (los viejos no traen `comments`). */
  private movementKind(mv: any): 'CREADO' | 'EDITADO' | 'BORRADO' {
    const c = String(mv?.comments ?? '').toUpperCase();
    if (c === 'CREADO' || c === 'EDITADO' || c === 'BORRADO') return c as any;
    if (mv?.attribute === '__created__') return 'CREADO';
    if (mv?.attribute === 'deleted' && (mv?.after === true || String(mv?.after).toLowerCase() === 'true')) return 'BORRADO';
    return 'EDITADO';
  }

  get filterChips(): FilterChip[] {
    if (!this.kindFilter) return [];
    return [{ key: 'kind', label: 'Tipo de edición', value: this.kindOptions.find(k => k.value === this.kindFilter)?.label ?? this.kindFilter }];
  }
  removeChip(key: string): void {
    if (key === 'kind') { this.kindFilter = ''; this.applyView(); }
  }

  /** Aplica tipo y texto sobre uiData y reinicia la paginación. */
  applyView(): void {
    const q = this.textFilter.trim().toLowerCase();
    this.viewData = this.uiData
      .map(d => ({ ...d, movements: this.kindFilter ? d.movements.filter((m: any) => m.kind === this.kindFilter) : d.movements }))
      .filter(d => d.movements.length > 0)
      .filter(d => !q || String(d.element).toLowerCase().includes(q)
        || d.movements.some((m: any) => [m.attribute, m.before, m.after, m.modifiedBy].some(v => String(v ?? '').toLowerCase().includes(q))));
    this.length = this.viewData.length;
    this.pagedList = this.viewData.slice(0, this.pageSize);
  }

  /** Filtrar resultados. */
  filterText(event: Event){
    this.textFilter = (event.target as HTMLInputElement).value ?? '';
    this.applyView();
  }

  /** Reemplazr todas las llaves que guardan ids por el valor correspondiente. */
  matchIds(history:any){
    //log.debug('[matchIds] this.usersObject', this.usersObject)
    //log.debug('[matchIds] history', history)
    history.forEach(h => {
      h.movements.forEach(mv => {
        mv.modifiedBy = this.usersObject[mv.modifiedBy as keyof typeof this.usersObject] ?? (mv.modifiedBy || 'Sin registro');
        switch (mv.attribute) {
          case 'operationRoom':
            mv.before = mv.before ? this.operationRoomsObject[mv.before as keyof typeof this.operationRoomsObject] ?? mv.before : '—';
            mv.after = mv.after ? this.operationRoomsObject[mv.after as keyof typeof this.operationRoomsObject] ?? mv.after : '—';
            break;
          case 'place':
          case 'hospital':
            mv.before = mv.before ? this.placesObject[mv.before as keyof typeof this.placesObject] ?? mv.before : '—';
            mv.after = mv.after ? this.placesObject[mv.after as keyof typeof this.placesObject] ?? mv.after : '—';
              break;
          case 'warehouse':
          case 'toWarehouse':
          case 'fromWarehouse':
            mv.before = mv.before ? this.warehouseObject[mv.before as keyof typeof this.warehouseObject] ?? mv.before: 'N/A';
            mv.after = mv.after ? this.warehouseObject[mv.after as keyof typeof this.warehouseObject] ?? mv.after : '—';
              break;
          case 'createdBy':
            mv.before = mv.before ? this.usersObject[mv.before as keyof typeof this.usersObject] ?? mv.before : '—';
            mv.after = mv.after ? this.usersObject[mv.after as keyof typeof this.usersObject] ?? mv.after : '—';
              break;
          case 'contract':
            mv.before = mv.before && Array.isArray(mv.before) ? mv.before.map(id => this.contractsObject[id] ?? id): (this.contractsObject[mv.before] ?? mv.before);
            mv.after = mv.after && Array.isArray(mv.after) ? mv.after.map(id => this.contractsObject[id] ?? id): (this.contractsObject[mv.after] ?? mv.after);
              break;
          case 'specialty':
          mv.before = mv.before ? this.specialtyObject[mv.before as keyof typeof this.specialtyObject] ?? mv.before: 'N/A';
          mv.after = mv.after ? this.specialtyObject[mv.after as keyof typeof this.specialtyObject] ?? mv.after : '—';
            break;
          case 'organization':
          mv.before = 'N/A';
          mv.after = this.organization;
            break;
          case 'code':
            mv.before = mv.before ? this.productObject[mv.before as keyof typeof this.productObject] ?? mv.before : '—';
            mv.after = mv.after ? this.productObject[mv.after as keyof typeof this.productObject] ?? mv.after: 'N/A';
            break;
          case 'itemNumber':
          case 'contractFileNumber':
            mv.before ? Object.keys(mv.before).forEach(key => {
              const newKey = this.contractsObject[key as keyof typeof this.contractsObject] ?? 'N/A';
              mv.before[newKey] = mv.before[key as keyof typeof mv.before];
              delete mv.before[key as keyof typeof mv.before];
            }) : 'N/A';
            mv.after ? Object.keys(mv.after).forEach(key => {
              const newKey = this.contractsObject[key as keyof typeof this.contractsObject] ?? 'N/A';
              mv.after[newKey] = mv.after[key as keyof typeof mv.after];
              delete mv.after[key as keyof typeof mv.after];
            }) : 'N/A';
            break;
          case 'manufacturer':
            mv.before = mv.before ? this.manufacturerObject[mv.before as keyof typeof this.manufacturerObject] ?? mv.before: 'N/A';
            mv.after = mv.after ? this.manufacturerObject[mv.after as keyof typeof this.manufacturerObject] ?? mv.after: 'N/A';
            break;
          case 'order':
            mv.before?.forEach(b => {
              //log.debug('[matchIds] b.contract', b.contract)
              b.contract = this.contractsObject[b.contract as keyof typeof this.contractsObject] ?? 'N/A';
            });
            mv.after?.forEach(a => {
              a.contract = this.contractsObject[a.contract as keyof typeof this.contractsObject] ?? 'N/A';
            });
            break;
          case 'doctor':
            mv.before = mv.before ? this.doctorObject[mv.before as keyof typeof this.doctorObject] ?? mv.before : '—';
            mv.after = mv.after ? this.doctorObject[mv.after as keyof typeof this.doctorObject] ?? mv.after : '—';
            break;
          case 'refund':
          case 'delivery':
          case 'consumption':
            //log.debug('[matchIds] stockObject', this.stockObject)
            mv.before = mv.before?.map(b => this.stockObject[b as keyof typeof this.stockObject] ?? 'N/A');
            mv.after = mv.after?.map(a => this.stockObject[a as keyof typeof this.stockObject] ?? 'N/A');
            break;
          case 'supplier':
            mv.before = mv.before ? this.supplierObject[mv.before as keyof typeof this.supplierObject] ?? mv.before: 'N/A';
            mv.after = mv.after ? this.supplierObject[mv.after as keyof typeof this.supplierObject] ?? mv.after: 'N/A';
            break;
          case 'procedure':
            mv.before = mv.before ? this.procedureObject[mv.before as keyof typeof this.procedureObject] ?? mv.before: 'N/A';
            mv.after = mv.after ? this.procedureObject[mv.after as keyof typeof this.procedureObject] ?? mv.after : '—';
            break;
          case 'numberUses':
            mv.before = mv.before ? String(mv.before): 'N/A';
            mv.after = mv.after ? String(mv.after): 'N/A';
            break;
          default:
              //El valor se queda igual porque no es un id
              break;
        }
      });
    })
    //log.debug('[matchIds] history', history)
    this.setUiData(history); //Acomodar la data en el formato necesario en el front
  }

  /** Acomodar la data en el formato necesario en el front */
  setUiData(history:any){
    history.forEach(edit => {
      let movements = edit.movements.map((mvRaw: any) => ({ ...mvRaw, kind: this.movementKind(mvRaw) })).map(({ attribute, modifiedBy, modifiedOn, before: rawBefore, after: rawAfter, kind}) => {
        // Booleanos y números se mostraban como "N/A": se traducen antes.
        const before = this.plainValue(attribute, rawBefore);
        const after = this.plainValue(attribute, rawAfter);
        return {
        kind,
        attribute: attribute === '__created__' ? 'Registro creado' : this.attributeLabel(attribute),
        modifiedBy: modifiedBy ?? 'N/A',
        modifiedOn: modifiedOn ?? 'N/A',
        //Cómo se acomodan before o after dependen del tipo de dato, ya que pueden guardar cadenas arreglos o booleanos
        before: before === null ? 'N/A' : //Si before es null
          typeof before === 'string' ? before : //Si before es una cadena
          Array.isArray(before) ? //Si before es un arreglo
                before.map(obj =>typeof obj === 'object' ?`[${Object.entries(obj).map(([key, value]) => `${key}:${value}`).join(', ')}]\n` : //Si before es un arreglo de objetos
                obj).join(', ') : //Si before es un arreglo de cadenas
          typeof before === 'object' ? Object.entries(before).map(([key, value]) => `${key}:${value}`).join(', ') : 'N/A', //Si before es un objeto
        after: after === null ? 'N/A' : //Si after es null
          typeof after === 'string' ? after : //Si after es una cadena
          Array.isArray(after) ? //Si after es un arreglo
                after.map(obj =>typeof obj === 'object' ?`[${Object.entries(obj).map(([key, value]) => `${key}:${value}`).join(', ')}]` : //Si after es un arreglo de objetos
                obj).join(', ') : //Si after es un arreglo de cadenas
          typeof after === 'object' ? Object.entries(after).map(([key, value]) => `${key}:${value}`).join(', ') : 'N/A', //Si after es un objeto
      };});
      this.uiData.push({
        element: edit.name ?? 'N/A',
        modifiedOn: edit.modifiedOn ?? 'N/A',
        movements: movements
      })
    });
    // Lo más reciente primero (dentro de cada elemento, también).
    const t = (v: any) => { const n = Date.parse(v); return isNaN(n) ? 0 : n; };
    this.uiData.forEach(d => d.movements.sort((a: any, b: any) => t(b.modifiedOn) - t(a.modifiedOn)));
    this.uiData.sort((a, b) => t(b.modifiedOn) - t(a.modifiedOn));
    this.selectModule = false;
    this.applyView();
  }

/**
 * @description Resetear el modulo
 */
resetModule(){
  this.selectModule = true;
  this.FormInfo.enable();
  this.FormInfo.reset();
  this.uiData = [];
  this.viewData = [];
  this.pagedList = [];
  this.elements = [];
  this.loaded = false;
  this.kindFilter = '';
  this.textFilter = '';
  this.length = 0;
  this.startDate = undefined;
  this.endDate = undefined;
}

/** Descargar el excel con la información. */
  async _downloadReport() {
    let tableStruct: TableStructureModel[] = [{columnKey: 'element', columnName: 'Elemento', type: 'string'},
                                              {columnKey: 'modifiedOn', columnName: 'Última modificación', type: 'string'},
    ];
    let excelData: any[] = [];
    
    this.viewData.forEach(data =>{
      if(data['movements'].length > 0){
        tableStruct.push({columnKey: 'attribute', columnName: '', type: 'string'},
                          {columnKey: 'before', columnName: '', type: 'string'},
                          {columnKey: 'after', columnName: '', type: 'string'},
                          {columnKey: 'historyModifiedOn', columnName: '', type: 'string'},
                          {columnKey: 'modifiedByName', columnName: '', type: 'string'},
                          {columnKey: 'kind', columnName: '', type: 'string'}
        );
        data['movements'].forEach((movement: any, i:number) => {
          if(i === 0){
            excelData.push({
              element: data.element,
              modifiedOn: data.modifiedOn,
              attribute: 'Atributo modificado',
              before: 'Valor anterior',
              after: 'Valor posterior',
              historyModifiedOn: 'Fecha de modificación',
              modifiedByName: 'Modificado por',
              kind: 'Tipo'
            })
          }
          excelData.push({
            element: '',
            modifiedOn: '',
            attribute: movement.attribute,
            before: movement.before,
            after: movement.after,
            historyModifiedOn: movement.modifiedOn,
            modifiedByName: movement.modifiedBy,
            kind: movement.kind
          })
        });
      }else{
        excelData.push({
          element: data.element,
          modifiedOn: data.modifiedOn
        })
      }
    })
    
    await this.simpleExcelService.simpleXLSX({
        fileName: `Historial - ${this.selectedModuleLabel || 'módulo'}`,
        sheets: [
            {
                sheetName: 'Historial',
                columns: tableStruct,
                data: excelData,
                header: [`Historial de ediciones — ${this.selectedModuleLabel}`],
                lineBreak: 1,
            }
        ],
    });
  }

  _returnMenu() {
    this.router.navigate(['/audit/menu']);
  }
}
